var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar'),_c('div',{staticClass:"relative md:ml-64 bg-blueGray-100"},[_c('admin-navbar'),(_vm.version===1)?_c('TranslationsV1',{attrs:{"contentModule":_vm.contentModule}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }